import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { withLeaflet, Path } from 'react-leaflet';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { polylineDecorator } from 'leaflet-polylinedecorator'; // eslint-disable-line  no-unused-vars

import logo from '../assets/map/arrow.svg';

var getPatterns = function getPatterns(props) {
  var color = props.color,
      selected = props.selected;
  var patterns = [];

  if (selected) {
    patterns.push({
      offset: 25,
      repeat: 100,
      symbol: L.Symbol.marker({
        rotate: true,
        markerOptions: {
          icon: L.icon({
            iconUrl: logo,
            iconAnchor: [8, 8],
            iconSize: [16, 16]
          })
        }
      })
    });
  } else {
    patterns.push({
      offset: 25,
      repeat: 100,
      symbol: L.Symbol.arrowHead({
        pixelSize: 10,
        polygon: false,
        pathOptions: {
          stroke: true,
          color: color
        }
      })
    });
  }

  return patterns;
};

var PolylineDecorator =
/*#__PURE__*/
function (_Path) {
  _inherits(PolylineDecorator, _Path);

  function PolylineDecorator() {
    _classCallCheck(this, PolylineDecorator);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolylineDecorator).apply(this, arguments));
  }

  _createClass(PolylineDecorator, [{
    key: "createLeafletElement",
    value: function createLeafletElement(props) {
      var positions = props.positions;
      var line = new L.Polyline(positions);
      return L.polylineDecorator(line, {
        patterns: getPatterns(props)
      });
    }
  }, {
    key: "updateLeafletElement",
    value: function updateLeafletElement(fromProps, toProps) {
      var positions = toProps.positions;
      this.leafletElement.setPaths(new L.Polyline(positions));
      this.leafletElement.setPatterns(getPatterns(toProps));
    }
  }]);

  return PolylineDecorator;
}(Path);

PolylineDecorator.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  })).isRequired,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool
};
PolylineDecorator.defaultProps = {
  selected: false
};
export default withLeaflet(PolylineDecorator);